import React, { useState, useEffect , useMemo , useRef} from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { MenuItem,
    Tooltip,
    TextField
} from '@material-ui/core';

import { useTable } from "react-table";

import { useForm } from 'react-hook-form';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import { monthCalendar } from '../../constants/models/monthCalendar';

import DetailPaymentService from '../../services/detail-advance-payment.service';

import '../../styles/style.scss';
import usersService from '../../services/users.service';

export const DetailAdvancePaymentScreen = () => {

  const { isLoggedIn, user } = useSelector( state => state.auth);
    const an8Logged = isLoggedIn? user.noCustomer:'---';

    const currencySelected = 'es-Mx'

    const dispatch = useDispatch();
    const history = useHistory();

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const todayDate = new Date();

    const [customers, setCustomers] = useState({
      isLoading: true,
      isDisabled: true,
      data:[]
    });

    const [yearsPayment, setYearsPayment] = useState({
      isLoading: false,
      isDisabled: true,
      data:[]});
    
    const [montPayment, setMonthPayment] = useState(monthCalendar);

    const [isLoadingFilters, setIsLoadingFilters] = useState(false);
    const [detailPayment, setDetailPayment] = useState([]);
    const detailPaymentRef = useRef();
    const [isDownloadFile, setIsDownloadFile] = useState(false)
  
    const [isLoadingData, setIsLoadingData] = useState(false);
  
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);
  
    detailPaymentRef.current = detailPayment;
 
    const {
        register,
        handleSubmit,
        getValues,
        setValue,
    } = useForm({
    });

    /**
     * Recuperar filtros
     */
    useEffect(() => {
      getCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

  /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   */
  const getCustomers = () =>{

    setCustomers({
      isLoading: true,
      isDisabled: true,
      data:[]
    })
    usersService.getCustomerAssociatesByAN8(an8Logged).then((response)=>{
      let customersResponse = response;
        
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data:customersResponse
      });
    }).catch((error)=>{
      console.log(error);
      setCustomers({
        isLoading: false,
        isDisabled: false,
        data:['']
      });
      
      if(sessionDifference > Number(tokenExpired)){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar clientes.');
      }
    });
  }

    const getYears = (an8) =>{
      setYearsPayment({
        isLoading: true,
        isDisabled: true,
        data: []
      });
      DetailPaymentService.getYearPayment(an8).then((response)=>{
        setYearsPayment({
          isLoading: false,
          isDisabled: false,
          data: response
        });
        setIsLoadingFilters(false);
      }).catch((error)=>{
        console.log(error);
        setYearsPayment({
          isLoading: false,
          isDisabled: false,
          data: []
        });
        setIsLoadingFilters(false);
        
        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al recuperar años.');
        }
      });
    }

    /** 
     * Recupera el an8 seleccionado
     * @author alSanchez - ETE
     * @version 1.0.0 - Enero 2024
     * 
    */
  const onCustomerChange = () =>{
    const params = getValues();
    if(params.an8 && params.an8 !== ''){ 
      getYears(params.an8);
      let date = new Date();

    const year = date.getFullYear();
    const month = date.getMonth()+1<10 ? `0${date.getMonth()+1}`: date.getMonth()+1;

    onSubmit(null, year, month, false); 
    }
  }

    /** 
   * Recupera el año seleccionado y realiza busqueda de meses
   * @author alSanchez - ETE
   * @version 1.0.0 - Enero 2024
   * 
  */
    const onYearChange = () => {
      setValue("month", null);
      const params = getValues();
      let monthArrayChange = monthCalendar;
  
      if(params.year >= todayDate.getFullYear()){
        monthArrayChange = monthCalendar.filter(({numberMount})=>Number(numberMount) <= todayDate.getMonth()+1);
      }
      setMonthPayment(monthArrayChange)
    }

    /**
     * Realiza la solicitud para recuperar datos de pago por filtros
     * @param {*} data - información del formulario
     * @param {string} year - año a consultar
     * @param {string} month - mes a consultar
     * @author alSanchez - ETE
     * @version 1.0.0 - Septiembre 2021

     */
    const onSubmit = (data, year, month) => {

      const element = document.getElementById('collapseExample');
      element.classList.remove('show');

      setDetailPayment([]);
      setIsLoadingData(true);
      setIsErrorResponse(false);

      const params = getValues();
      const an8 = params.an8;
      let dataFilter = {};


        if(!data) {
          dataFilter = {
            an8: an8,
            year: year,
            month: month
          }
        } else {
          dataFilter = {
            an8: params.an8,
            year: params.year,
            month: params.month
          }
        }

      getServiceDetailPayment(dataFilter);
    };


    /**
     * Realiza solicitud a servicio para recuperar detalle de pagos procesados
     * @param {*} dataFilter - datos de filtos
     * @author alSanchez - ETE
     * @version 1.0.0 - Octubre 2021
     */
    const getServiceDetailPayment = (dataFilter) =>{
      DetailPaymentService.getAlldetailPaymentByFilters(dataFilter)
      .then((response) => {
        setIsErrorResponse(false);
        setIsLoadingData(false);
        setDetailPayment(response);
      })
      .catch((error) => {
        setIsLoadingData(false);
        console.log(error);
        if(error.response){
          setErrorResponse(error.response.data.mensaje);
          if(sessionDifference > Number(tokenExpired)){
            sesionExpired(dispatch, history);
          }
        } else{
          setErrorResponse(error);
          actionErrorConnection(error);
        }
        setIsErrorResponse(true);
      });
    }

    /**
     * Campos de la tabla
     */
    const columns = useMemo(
      () => [
        {
          Header: 'Cliente',
          accessor: 'an8'
        },
        {
          Header: "Monto",
          accessor: "amount",
        },
        {
          Header: "Descripción",
          accessor: "description",
        }
        ,
        {
          Header: "Método de pago",
          accessor: "paymentMethod",
        },
        {
          Header: 'Fecha',
          accessor: 'date'
        }
      ],
      []
    );
  
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow
    } = useTable({
      columns,
      data: detailPayment,
    });

    const formatDecimal = (detailPayment) =>{
      return detailPayment.map((el)=>{
        return {
          ...el,
          amount: el.amount ?  String(parseFloat( el.amount).toFixed(2)) : "0.00"
        }
      })
    }
    const downloadFile = ()=>{
      setIsDownloadFile(true)
      const params = getValues();
      const an8 = params.an8;

      const fileName = `pagos_anticipo_${an8}_${params.year}-${params.month}`;
      const formatedDetailPayment =  formatDecimal(detailPayment)
      
      DetailPaymentService.downloadDetailAdvancedPaymentsXls(an8, formatedDetailPayment).then((response) =>{
        const byteString = window.atob(response.split(',')[1]);
              const mimeString = response.split(',')[0].split(':')[1].split(';')[0];

              const ab = new ArrayBuffer(byteString.length);
              const ia = new Uint8Array(ab);
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
              }

              const dataBlob = new Blob([ab], { type: mimeString });

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
                setIsDownloadFile(false);
                return
              }

              const url = window.URL.createObjectURL(dataBlob);
              const link = document.createElement('a');
              link.href = url
              link.setAttribute('download', `${fileName}.xls`);
              document.body.appendChild(link);
              link.click();
              link.remove();

              setIsDownloadFile(false);
            },
            (error)=>{
              setIsDownloadFile(false);
              actionErrorConnection(error, 'Error al descargar archivo xls.');
            });
    }

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />


                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                      <span className="h4">Pagos de anticipo</span>
                    </div>
                  
                    <div className="col-12 pt-1 pb-3 ps-2 pe-2">
                    <div className="row ">
                      <div className="col-12 ">
                        <div className="w-100 d-flex justify-content-end">
                        {
                            isDownloadFile ?
                              <Tooltip title="Descargargando..." placement="top-start" arrow>
                                <div className="custom-icon-loading me-1">
                                  <i className="fas fa-spinner fa-spin"></i>
                                </div>
                              </Tooltip>
                              :
                              <Tooltip title="Descargar resultados" placement="top-start" arrow>
                                <div>
                                  <button
                                    className="btn custom-btn-icons"
                                    onClick={()=>downloadFile()}
                                    type="button"
                                    disabled={isLoadingData || isErrorResponse || detailPayment.length < 1}
                                  >
                                    <i className="fas fa-download"></i>
                                  </button>
                                </div>
                              </Tooltip>
                          }
                        {(customers.isLoading || yearsPayment.isLoading) && 
                          <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                            <div className="custom-icon-loading me-1">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>
                          </Tooltip>
                        }
                          <Tooltip title="Filtrar" placement="top-start" arrow>
                            <button className="btn custom-btn-icons" 
                            type="button" data-bs-toggle="collapse" 
                            data-bs-target="#collapseExample" aria-expanded="false" 
                            aria-controls="collapseExample">
                              <i className="fas fa-filter"></i>
                            </button>
                          </Tooltip>
                        </div>
                        <div className="collapse show" id="collapseExample">
                          <div className="filter-continer">
                            <div className="container mt-3">
                              <form className="row">
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                    select
                                    id="an8"
                                    name="an8"
                                    label="Num. cliente*"
                                    variant="outlined"
                                    size="small" 
                                    disabled={customers.isDisabled || customers.isLoading}
                                    fullWidth
                                    defaultValue={''}
                                    {...register('an8')}
                                    onBlur={onCustomerChange}
                                    >
                                        <MenuItem value="">Seleccionar cliente</MenuItem>
                                    {customers.data.map(({noCustomer, name}) => (
                                        <MenuItem key={noCustomer} value={noCustomer}>
                                        {noCustomer} - {name}
                                        </MenuItem>
                                    ))}
                                  </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                          select
                                          id="year"
                                          name="year"
                                          label="Año"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('year')}
                                          defaultValue={""}
                                          disabled={yearsPayment.isDisabled || yearsPayment.isLoading}
                                          onBlur={onYearChange}
                                          >
                                              <MenuItem value="">Seleccionar año</MenuItem>
                                              {yearsPayment.data?.length === 0 && <MenuItem value="">Sin registros</MenuItem>}
                                          {yearsPayment.data?.map((option) => (
                                              <MenuItem key={option} value={option}>
                                              {option}
                                              </MenuItem>
                                          ))}
                                        </TextField>
                                </div>
                                <div className="col-md-5 col-lg-4 mb-3">
                                <TextField
                                          select
                                          id="month"
                                          name="month"
                                          label="Mes"
                                          variant="outlined"
                                          size="small" 
                                          fullWidth
                                          {...register('month')}
                                          defaultValue={""}
                                          disabled={yearsPayment.isDisabled || yearsPayment.isLoading}
                                          >
                                              <MenuItem value="">Seleccionar mes</MenuItem>
                                          {montPayment.map((option) => (
                                              <MenuItem key={option.id} value={option.numberMount}>
                                              {option.name}
                                              </MenuItem>
                                          ))}
                                        </TextField>
                                </div>
                                <div className="col-12 w-100 d-flex justify-content-end">
                                  <Tooltip title="Buscar" placement="top-start" arrow>
                                    <div>
                                      <button 
                                      className="ms-2 mb-3 btn custom-btn"
                                      disabled={isLoadingData || isLoadingFilters}
                                      onClick={handleSubmit(onSubmit)}
                                      type='submit'
                                      data-bs-toggle="collapse" 
                                      data-bs-target="#collapseExample" 
                                      aria-expanded="false" 
                                      aria-controls="collapseExample"
                                      >
                                        <i className="fas fa-search"></i>
                                      </button>
                                    </div>
                                  </Tooltip>
                                </div>
                            </form>
                            </div>
                          
                          </div>
                        </div>
                            
                            
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <table
                            className=""
                            {...getTableProps()}
                          >
                            <thead>
                              {headerGroups.map((headerGroup, i) => (
                                <tr {...headerGroup.getHeaderGroupProps()} className="border-content " key={i}>
                                  {headerGroup.headers.map((column, j) => (
                                    <th {...column.getHeaderProps()}
                                    className="border-element header-element header-text pt-3 pb-3" key={j}>
                                      {column.render("Header")}
                                    </th>
                                  ))}
                                </tr>
                              ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                              {rows.map((row) => {
                                prepareRow(row);
                                return (
                                  <React.Fragment key={row.getRowProps().key}>
                                    <tr className="element-row border-content">
                                      {row.cells.map((cell,index) => {
                                        return (
                                          <td className="border-element content-text padding-row"
                                          {...cell.getCellProps()} key={index}>

                                            {
                                              cell.value ? 
                                                    (((cell.column.Header === 'Monto' ?
                                                    `$ ${parseFloat(cell.value).toLocaleString(currencySelected)}` : cell.render("Cell"))))
                                                   : '---'
                                              }
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  </React.Fragment>
                                );
                              })}
                            </tbody>
                          </table>
                          {(isErrorResponse) &&
                            <div className="error-message border-content pt-4 pb-4">
                              <span className="">Error: {errorResponse && errorResponse.toString()}</span>
                            </div>}
                          {(isLoadingData) &&
                            <div className="border-content pt-4 pb-4 custom-icon-loading">
                              <i className="fas fa-spinner fa-spin"></i>
                            </div>}
                            {(detailPayment.length === 0 && !isLoadingData && !isErrorResponse) &&
                            <div className="element-row-message border-content pt-4 pb-4 ">
                              <span>Los filtros seleccionanos no devolvieron coincidencias.</span>
                            </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
            <Footer/>
        </>
    )
}
